/* import __COLOCATED_TEMPLATE__ from './metric-picker-item.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    item: {
      text: string;
    };
    componentAttrs: {
      color: string;
    };
  };
  Blocks: {
    default: [];
  };
}

const MetricPickerItem = templateOnlyComponent<Signature>();
export default MetricPickerItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    MetricPickerItem: typeof MetricPickerItem;
    'metric-picker-item': typeof MetricPickerItem;
  }
}
